import { Navigate, useLocation } from "react-router-dom";

// Keep existing shared links working; configuration is parsed only by Playground.
export default function PreviewRedirect() {
  const { search, hash } = useLocation();
  return <Navigate to={{ pathname: "/stream", search, hash }} replace />;
}
